import React from 'react';
import * as s from './styled-info';
import { formatEnergyAutoUnit } from '../../../../utils';

// Machine-card do design Operacional.html.
// - badge cyan com icone chip (lucide-style)
// - title: nome (UCHA — SABESP <descricao>)
// - sub: "Energia consumida/gerada: <valor> + unidade auto"
//
// Net energy positivo em operacao normal:
//   UCHA: Reversa - Ativa  (gerou energia)
//   EBA:  Ativa - Reversa  (consumiu energia)
// Negativo = anomalia (sinal invertido).
const InfoAplicacao = ({ nome, descricao, energia, type }) => {
  const hasEnergyData =
    energia &&
    typeof energia.EnergiaAtiva === 'number' &&
    typeof energia.EnergiaAtivaReversa === 'number';
  const displayEnergy = hasEnergyData
    ? type === 'eba'
      ? energia.EnergiaAtiva - energia.EnergiaAtivaReversa
      : energia.EnergiaAtivaReversa - energia.EnergiaAtiva
    : null;
  const energyLabel = type === 'ucha' ? 'gerada' : 'consumida';
  const tipoLabel = type === 'ucha' ? 'UCHA' : type === 'eba' ? 'EBA' : 'USINA';
  // descricao = nome do parque/maquina (ex.: "SABESP Capão Redondo")
  const ttl = descricao ? `${tipoLabel} — ${descricao}` : (nome || tipoLabel);

  return (
    <s.Container>
      <s.Badge>
        {/* lucide:cpu (mesmo glyph do IChip do design) */}
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="6" y="6" width="12" height="12" rx="1.5" />
          <path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" />
        </svg>
      </s.Badge>
      <s.Info>
        <s.Title>{ttl}</s.Title>
        <s.Sub>
          {displayEnergy !== null ? (
            <>
              Energia {energyLabel}:
              <b>{formatEnergyAutoUnit(displayEnergy, 'kWh')}</b>
            </>
          ) : (
            <>—</>
          )}
        </s.Sub>
      </s.Info>
    </s.Container>
  );
};

export default InfoAplicacao;
